import { isCoreClassifier } from './isCoreClassifier'
import { ClassifierInterface } from './types'

/**
 * Sorts an array of classifiers so that those considered "core" appear first.
 * @param {ClassifierInterface[]} classifiers - Array of classifier objects to sort.
 * @returns {ClassifierInterface[]} A new array where core classifiers (as determined by `isCoreClassifier`) come before non-core classifiers.
 */
export function orderClassifiersByType(classifiers: ClassifierInterface[]): ClassifierInterface[] {
  return classifiers.sort((c1: ClassifierInterface, c2: ClassifierInterface) => {
    const isC1Core = isCoreClassifier(c1.type)
    const isC2Core = isCoreClassifier(c2.type)

    if (isC1Core && !isC2Core) return -1
    if (!isC1Core && isC2Core) return 1
    return 0
  })
}
